
import { Sale } from "@/models/base";
import Vue from "vue";
import { SaleEditState } from "../../utils/sale-edit/sale-edit-state";
import AppDefaultSettings from "./SaleEditSaveModalDefaultSettings.vue";
import { SaleSettings } from "@/models/user-configs/sale-settings";
import { UserConfigService } from "@/services/user-config-service";
import AppSaleEditSaveModalActions from "./SaleEditSaveModalActions.vue";
import { SaleEditStateSaveModalData } from "@/utils/sale-edit/sale-edit-state-save-modal-data";
import { MainSocketService } from "@/services";
import { isSaleTypeAllowedForBankBookings } from "@/utils/bank-booking-sale-types";
export default Vue.extend({
	data() {
		return {
			preventClose: false,
			loading: false,
			quickBankEdit: false,
			saveProgress: undefined as number | undefined
		};
	},
	props: {
		state: {
			type: Object as () => SaleEditState,
			required: true
		}
	},
	computed: {
		sale(): Sale {
			return this.state.sale;
		},
		modalTitle(): string {
			return this.saleTypeName;
		},
		saleTypeName(): string {
			return `${this.sale.getTypeName(this.$i18n.locale)} ${(this.sale.ComputedFriendlyID ? this.sale.ComputedFriendlyID : "")}`;
		},
		saleSettings(): SaleSettings {
			return UserConfigService.getSaleSettings();
		},
	},
	watch: {
		"sale.SaveProgressTrackingKey": {
			immediate: true,
			handler(currentVal, oldVal){
				MainSocketService.off(`/sales/save-progress/${oldVal}`, this.onSaveProgress, this);
				MainSocketService.on(`/sales/save-progress/${currentVal}`, this.onSaveProgress, this);
			}
		}
	},
	methods: {
		close() {
			this.state.saveModalOpen = false;
		},
		onSaveProgress(progress:number, status:string, ...data:any){
			console.log("SALE SAVE PROGRESS", progress, status, ...data);
			this.saveProgress = progress;
			if (progress == 100) {
				this.saveProgress = undefined;
			}
		}
	},
	created(){
		this.state.saveModalData = new SaleEditStateSaveModalData();
		if (!this.state.config){
			return;
		}
		this.state.saveModalData.quickBankEdit = this.state.config.AskforBankTransfer && this.state.config.AskforBankTransferDefaultOn
			&& isSaleTypeAllowedForBankBookings(this.sale.TypeID);
	},
	destroyed(){
		MainSocketService.offAll(this);
	},
	components: {
		AppDefaultSettings,
		AppSaleEditSaveModalActions
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
